export default class ScheduleSelectionController {
    constructor({ totalDays = 31, isDayDisabled = () => false }) {
        this.totalDays = totalDays;
        this.isDayDisabled = isDayDisabled;

        this.selectedDays = [];
        this.initialSelectedDays = [];

        this.isDragging = false;
        this.dragMode = null;
        this.startDay = null;
    }

    getSelectedDays() {
        return this.selectedDays;
    }

    getIsDragging() {
        return this.isDragging;
    }

    setSelectedDays(days) {
        this.selectedDays = [...days];
    }

    isAllSelected() {
        if (this.selectedDays.length !== this.totalDays) return false;

        for (let i = 1; i <= this.totalDays; i++) {
            if (!this.selectedDays.includes(i)) return false;
        }

        return true;
    }

    selectAll() {
        const all = [];

        for (let i = 1; i <= this.totalDays; i++) {
            if (!this.isDayDisabled(i)) {
                all.push(i);
            }
        }

        this.selectedDays = all;
        return this.selectedDays;
    }

    clear() {
        this.selectedDays = [];
        return this.selectedDays;
    }

    handleMouseDown(day) {
        if (this.isDayDisabled(day)) return this.selectedDays;

        const isSelected = this.selectedDays.includes(day);

        this.dragMode = isSelected ? "unselect" : "select";
        this.startDay = day;
        this.isDragging = true;

        this.initialSelectedDays = [...this.selectedDays];

        return this.applyRange(day);
    }

    handleMouseEnter(day) {
        if (!this.isDragging || this.startDay === null) return this.selectedDays;
        if (this.isDayDisabled(day)) return this.selectedDays;

        return this.applyRange(day);
    }

    handleMouseUp() {
        this.isDragging = false;
        this.dragMode = null;
        this.startDay = null;
        this.initialSelectedDays = [];
    }

    applyRange(currentDay) {
        const start = Math.min(this.startDay, currentDay);
        const end = Math.max(this.startDay, currentDay);

        const range = [];
        for (let i = start; i <= end; i++) {
            if (!this.isDayDisabled(i)) {
                range.push(i);
            }
        }

        let updated = [...this.initialSelectedDays];

        if (this.dragMode === "select") {
            range.forEach(day => {
                if (!updated.includes(day)) {
                    updated.push(day);
                }
            });
        }

        if (this.dragMode === "unselect") {
            updated = updated.filter(day => !range.includes(day));
        }

        this.selectedDays = [...updated].sort((a, b) => a - b);

        return [...this.selectedDays];
    }

    setIsDayDisabled(fn) {
        this.isDayDisabled = fn;
    }

    setTotalDays(total) {
        this.totalDays = total;

        this.selectedDays = this.selectedDays.filter(day => day <= total);

        this.initialSelectedDays = this.initialSelectedDays.filter(day => day <= total);
    }
}
